/**
 * Catalogo di testi italiani per la funzione commerce
 * (`@gamecodex/world-ui` → `features/commerce`).
 *
 * Le chiavi rispecchiano le chiamate `t('commerce.*')` nei componenti React della funzione.
 * I valori sono le stringhe italiane originali estratte durante lo sweep i18n.
 */
export const commerceIt = {
  // DtrpgClaimPage.tsx
  'commerce.dtrpg.seoTitle': 'Reclama la Tua Libreria',
  'commerce.dtrpg.seoDescription': 'Importa la tua libreria DriveThruRPG e reclama i tuoi PDF di Grymwyrd.',
  'commerce.dtrpg.heading': 'Reclama la Tua Libreria',
  'commerce.dtrpg.intro':
    'Hai acquistato Grymwyrd su DriveThruRPG o finanziato la campagna? Accedi con l\'email di acquisto per importare la tua libreria e reclamare le tue copie.',
  'commerce.dtrpg.sendLinkError': 'Non possiamo inviare il tuo link di accesso in questo momento. Riprova tra poco.',
  'commerce.dtrpg.checkInboxPrefix': 'Controlla la tua casella di posta a',
  'commerce.dtrpg.checkInboxSuffix':
    'Se quell\'email ha finanziato o acquistato Grymwyrd, il link di accesso è in arrivo — cliccalo per tornare qui e reclamare la tua libreria.',
  'commerce.dtrpg.linkAutoSignIn': 'Il link ti accede automaticamente — nessuna password necessaria.',
  'commerce.dtrpg.purchaseEmailLabel': 'La tua email di acquisto / finanziamento',
  'commerce.dtrpg.sendingLink': 'Invio del link…',
  'commerce.dtrpg.emailLinkCta': 'Inviami un link di accesso',
  'commerce.dtrpg.signedInAs': 'Accesso effettuato come',
  'commerce.dtrpg.signOut': 'Esci',
  'commerce.dtrpg.dtrpgEmailLabel': 'Email DriveThruRPG',
  'commerce.dtrpg.dtrpgEmailOptional': '(facoltativo — se diversa da quella precedente)',
  'commerce.dtrpg.dtrpgEmailHelp': 'Usiamo questa per abbinare i tuoi acquisti DriveThruRPG quando ti concediamo la libreria.',
  'commerce.dtrpg.libraryHeading': 'La tua libreria Grymwyrd',
  'commerce.dtrpg.noTitles': 'Nessun titolo importabile è ancora configurato.',
  'commerce.dtrpg.claimNotInLibrary':
    'Questo titolo non è ancora nella tua libreria. Assicurati di aver usato l\'email di acquisto corretta.',
  'commerce.dtrpg.claimSessionExpired': 'La tua sessione è scaduta — accedi di nuovo.',
  'commerce.dtrpg.claimError': 'Non possiamo reclamare questo titolo in questo momento. Riprova.',
  'commerce.dtrpg.preparingCopy': 'Preparazione della tua copia…',
  'commerce.dtrpg.download': 'Scarica',
  'commerce.dtrpg.preparing': 'Preparazione…',
  'commerce.dtrpg.claiming': 'Reclamo in corso…',
  'commerce.dtrpg.claim': 'Reclama',

  // PaywallPrompt.tsx
  'commerce.paywall.checkoutFailed': 'Il checkout non ha potuto essere aperto. Riprova tra poco.',
  'commerce.paywall.signInToPurchase': 'Accedi per completare questo acquisto.',
  'commerce.paywall.vaultSealed': 'La cassaforte del mercante è sigillata per ora — riprova tra poco.',
  'commerce.paywall.signInToUnlock': 'Accedi per sbloccare',
  'commerce.paywall.comingSoonTitle': 'Questo acquisto arriverà presto',
  'commerce.paywall.priceComingSoon': '{price} — arriverà presto',
  'commerce.paywall.comingSoon': 'Arriverà presto',
  'commerce.paywall.openingVault': 'Apertura della cassaforte…',
  'commerce.paywall.unlockPrice': 'Sblocca — {price}',
  'commerce.paywall.unlock': 'Sblocca',

  // MarketplacePage.tsx
  'commerce.marketplace.installSuccess': 'Installato "{name}" sul tuo tavolo.',
  'commerce.marketplace.installNotOwned': 'Non possiedi ancora questo pacchetto — l\'acquisto di pacchetti arriverà presto.',
  'commerce.marketplace.installHostOnly': 'Solo il padrone del tavolo può installare un pacchetto.',
  'commerce.marketplace.installError': 'Non possiamo installare questo pacchetto. Riprova.',
  'commerce.marketplace.installed': 'Installato',
  'commerce.marketplace.installing': 'Installazione…',
  'commerce.marketplace.installOnTable': 'Installa sul tavolo',
  'commerce.marketplace.seoTitle': 'Marketplace — Pacchetti',
  'commerce.marketplace.seoDescription':
    'Sfoglia e installa pacchetti di contenuti creati da altri — mappe, scene, documenti e preset pronti — sui tuoi tavoli.',
  'commerce.marketplace.eyebrow': 'Marketplace',
  'commerce.marketplace.heading': 'Pacchetti di Contenuto',
  'commerce.marketplace.intro':
    'Mappe, scene, documenti e preset per iniziare subito — installali sui tuoi tavoli con un click.',
  'commerce.marketplace.installingOnto': 'Installazione sul tavolo {tableId}.',
  'commerce.marketplace.signInHeading': 'Accedi per vedere i tuoi pacchetti',
  'commerce.marketplace.signInBlurb': 'Il catalogo dei pacchetti è legato al tuo account creatore.',
  'commerce.marketplace.signIn': 'Accedi',
  'commerce.marketplace.loading': 'Convocazione dei tuoi pacchetti…',
  'commerce.marketplace.noPacksHeading': 'Nessun pacchetto ancora',
  'commerce.marketplace.noPacksBlurb':
    'Non hai ancora pubblicato pacchetti. Un marketplace pubblico per sfogliare i pacchetti di altri creatori arriverà presto.',
  'commerce.marketplace.footer': 'La sfoglia dei pacchetti di altri creatori e i pacchetti a pagamento arriveranno presto.',

  // SubscriberPerksPage.tsx
  'commerce.subscriber.perk1Title': 'Tavoli riservati agli abbonati',
  'commerce.subscriber.perk1Blurb': 'Siedi ai tavoli che i tuoi padroni preferiti riservano agli abbonati.',
  'commerce.subscriber.perk2Title': 'Contenuti esclusivi e anticipati',
  'commerce.subscriber.perk2Blurb': 'Accedi a capitoli di campagne, scene e documenti prima di chiunque altro.',
  'commerce.subscriber.perk3Title': 'Stile da abbonato',
  'commerce.subscriber.perk3Blurb': 'Un segno del tuo status sul tuo profilo e al tavolo.',
  'commerce.subscriber.seoTitle': 'Vantaggi per Abbonati',
  'commerce.subscriber.seoDescription':
    'Diventa abbonato per tavoli esclusivi, contenuti anticipati e stile da abbonato.',
  'commerce.subscriber.heading': 'Diventa Abbonato',
  'commerce.subscriber.intro':
    'Sostieni i padroni e i creatori che ami — e sblocca i vantaggi che riservano al loro circolo interno.',
  'commerce.subscriber.activeHeading': 'Sei un abbonato',
  'commerce.subscriber.activeBlurb':
    'I tuoi vantaggi sono attivi. Cerca lo stemma dell\'abbonato sui tavoli a cui puoi unirti.',
  'commerce.subscriber.findTable': 'Trova un tavolo da abbonato',
  'commerce.subscriber.paywallTitle': 'Abbonato Grymwyrd',
  'commerce.subscriber.paywallBlurb':
    'Sblocca tavoli riservati agli abbonati, contenuti anticipati e il tuo stile da abbonato.',
  'commerce.subscriber.paywallPrice': 'da 5€/mese',

  // TicketCheckoutPage.tsx
  'commerce.ticket.checkoutFailed': 'Il checkout non ha potuto essere aperto. Riprova tra poco.',
  'commerce.ticket.signInToBuy': 'Accedi per acquistare un posto a questo tavolo.',
  'commerce.ticket.boxOfficeClosed': 'La biglietteria è chiusa per ora — riprova tra poco.',
  'commerce.ticket.seoTitle': 'Acquista un Posto',
  'commerce.ticket.seoDescription': 'Prenota il tuo posto a un tavolo con biglietteria.',
  'commerce.ticket.eyebrow': 'Tavolo con Biglietteria',
  'commerce.ticket.heading': 'Prenota il Tuo Posto',
  'commerce.ticket.loading': 'Caricamento del tavolo…',
  'commerce.ticket.notFoundHeading': 'Tavolo non trovato',
  'commerce.ticket.notFoundBlurb': 'Questo tavolo potrebbe aver chiuso, oppure le sue porte non si sono mai aperte.',
  'commerce.ticket.backToLobby': 'Torna nella lobby',
  'commerce.ticket.freeHeading': 'Questo tavolo è gratuito',
  'commerce.ticket.freeBlurb': 'Nessun biglietto necessario — tirati su una sedia.',
  'commerce.ticket.goToLobby': 'Vai alla lobby',
  'commerce.ticket.untitledTable': 'Tavolo senza titolo',
  'commerce.ticket.seatPrice': 'Prezzo del posto',
  'commerce.ticket.spectatorsNote': 'Anche gli spettatori devono avere un biglietto per questo tavolo.',
  'commerce.ticket.paymentReceived': 'Pagamento ricevuto — il tuo posto è prenotato. Vai alla lobby per prenderlo.',
  'commerce.ticket.signInToBuySeat': 'Accedi per acquistare un posto',
  'commerce.ticket.openingBoxOffice': 'Apertura della biglietteria…',
  'commerce.ticket.buySeatPrice': 'Acquista posto — {price}',
  'commerce.ticket.comingSoonTitle': 'La biglietteria arriverà presto',
  'commerce.ticket.ticketingComingSoon': 'Biglietteria in arrivo',
  'commerce.ticket.comingSoonFooter': 'I posti a pagamento stanno quasi arrivando. Per ora, chiedi all\'host un invito gratuito.',

  // TipGoalManagerPage.tsx
  'commerce.tip.errHostOnlyGoal': 'Solo il padrone del tavolo può gestire gli obiettivi.',
  'commerce.tip.errHostOnlyBounty': 'Solo il padrone del tavolo può gestire le taglie.',
  'commerce.tip.errMaxGoal': 'Hai raggiunto il numero massimo di obiettivi per questo tavolo.',
  'commerce.tip.errMaxBounty': 'Hai raggiunto il numero massimo di taglie per questo tavolo.',
  'commerce.tip.errMissingGoal': 'Questo obiettivo manca di dettagli obbligatori.',
  'commerce.tip.errMissingBounty': 'Questa taglia manca di dettagli obbligatori.',
  'commerce.tip.errSignIn': 'Accedi come padrone per gestire questo tavolo.',
  'commerce.tip.errSaveFailedGoal': 'Non possiamo salvare l\'obiettivo. Riprova.',
  'commerce.tip.errSaveFailedBounty': 'Non possiamo salvare la taglia. Riprova.',
  'commerce.tip.goalValidation': 'Aggiungi un\'etichetta e un obiettivo di dollari positivo.',
  'commerce.tip.goalAdded': 'Obiettivo "{label}" aggiunto.',
  'commerce.tip.goalLabelPlaceholder': 'Etichetta dell\'obiettivo (es. Evoca il boss)',
  'commerce.tip.targetPlaceholder': 'Obiettivo $',
  'commerce.tip.cuePlaceholder': 'Segnale quando raggiunto (es. fanfara)',
  'commerce.tip.addGoal': 'Aggiungi obiettivo',
  'commerce.tip.bountyValidation': 'Aggiungi un\'etichetta, un obiettivo positivo e un innesco.',
  'commerce.tip.bountyAdded': 'Taglia "{label}" aggiunta.',
  'commerce.tip.bountyLabelPlaceholder': 'Etichetta della taglia (es. Nat 20 salva il gruppo)',
  'commerce.tip.triggerPlaceholder': 'Innesco (es. un naturale 20)',
  'commerce.tip.addBounty': 'Aggiungi taglia',
  'commerce.tip.signInToManage': 'Accedi per gestire questo tavolo.',
  'commerce.tip.bountyClaimed': 'Taglia "{label}" rivendicata.',
  'commerce.tip.seoTitle': 'Obiettivi di Mancia & Taglie',
  'commerce.tip.seoDescription': 'Imposta obiettivi di mancia e taglie per il tuo tavolo.',
  'commerce.tip.backToLobby': 'Torna alla lobby',
  'commerce.tip.heading': 'Obiettivi di Mancia & Taglie',
  'commerce.tip.intro':
    'Imposta obiettivi e taglie per il tuo tavolo. Quando la tazza trabocca, il segnale si attiva per il tuo pubblico. La visualizzazione in diretta è gestita dal tuo overlay di trasmissione.',
  'commerce.tip.loading': 'Lettura del registro…',
  'commerce.tip.loadErrorTitle': 'Impossibile caricare il registro',
  'commerce.tip.raisedSoFar': 'Raccolto finora:',
  'commerce.tip.tipGoalsHeading': 'Obiettivi di Mancia',
  'commerce.tip.noGoals': 'Nessun obiettivo ancora — aggiungi il tuo primo qui sotto.',
  'commerce.tip.reachedAria': 'raggiunto',
  'commerce.tip.bountiesHeading': 'Taglie',
  'commerce.tip.noBounties': 'Nessuna taglia ancora — aggiungi la tua prima qui sotto.',
  'commerce.tip.whenLabel': '· quando: {trigger}',
  'commerce.tip.claimed': 'Rivendicata',
  'commerce.tip.claimTitleReady': 'Segna questa taglia come rivendicata',
  'commerce.tip.claimTitleNotFunded': 'Non ancora finanziata',
  'commerce.tip.claim': 'Rivendica',
} as const
